import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.GeneralMeetingsView.heading',
    defaultMessage: 'Walne zgromadzenia'
  },
  lastAdded: {
    id: 'views.GeneralMeetingsView.lastAdded',
    defaultMessage: 'OSTATNIO DODANE'
  },
  nothingToShow: {
    id: 'views.GeneralMeetingsView.nothingToShow',
    defaultMessage: 'Brak artykułów do wyświetlenia'
  },
  others: {
    id: 'views.GeneralMeetingsView.others',
    defaultMessage: 'POZOSTAŁE'
  },
  categories: {
    id: 'views.GeneralMeetingsView.categories',
    defaultMessage: 'KATEGORIE'
  },
  taxonomyAll: {
    id: 'views.GeneralMeetingsView.categories.all',
    defaultMessage: 'Wszystkie'
  },
  publicationDate: {
    id: 'views.GeneralMeetingsView.publicationDate',
    defaultMessage: 'DATA PUBLIKACJI'
  },
  filter: {
    id: 'views.GeneralMeetingsView.filter.all',
    defaultMessage: 'Wszystkie'
  },
  tag1: {
    id: 'views.GeneralMeetingsView.tag1',
    defaultMessage: 'Case Studies'
  },
  tag2: {
    id: 'views.GeneralMeetingsView.tag2',
    defaultMessage: 'Nasi eksperci'
  },
  tag3: {
    id: 'views.GeneralMeetingsView.tag3',
    defaultMessage: 'Media o nas'
  },
  button: {
    id: 'views.GeneralMeetingsView.button',
    defaultMessage: 'Zobacz więcej ...'
  },
  journalistContact: {
    id: 'views.GeneralMeetingsView.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  }
});



// WEBPACK FOOTER //
// ./src/views/GeneralMeetings/GeneralMeetingsView.intl.js